import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { HomeComponent } from './home/home.component';
import { MonitorComponent } from './monitor/monitor.component';
import { AuthGuardService } from './services/auth/auth.service';
import { MonitorItemComponent } from './monitor-item/monitor-item.component';
import { PrijaviNapakoComponent } from './HELPDESK/prijavi-napako/prijavi-napako.component';
import { LoginPartnerComponent } from './login-partner/login-partner.component';
import { PregledHelpdeskaComponent } from './HELPDESK/pregled-helpdeska/pregled-helpdeska.component';
import { AuthGuardPartnerServiceService } from './services/auth/auth-guard-partner-service.service';
import { AuthGuardSharedServiceService } from './services/auth/auth-guard-shared-service.service';
import { UrediTaskComponent } from './HELPDESK/uredi-task/uredi-task.component';
import { NgModule } from '@angular/core';
import { MailTokenComponent } from './HELPDESK/mail-token/mail-token.component';
import { AnalizaComponent } from './analiza/analiza.component';
import { SaleHomeComponent } from './sale/sale-home/sale-home.component';
import { SaleFilterComponent } from './sale/sale-filter/sale-filter.component';
import { SaleSelectComponent } from './sale/sale-select/sale-select.component';
import { AuthUrediTaskGuard } from './services/auth/auth-uredi-task.guard';
import { SaleSkladisceDesktopComponent } from './sale/sale-skladisce-desktop/sale-skladisce-desktop.component';
import { HelpdeskTabComponent } from './HELPDESK/helpdesk-tab/helpdesk-tab.component';
import { MapBubbleChartComponent } from './analiza/map-bubble-chart/map-bubble-chart.component';
import { RepositoryComponent } from './repository/repository.component';
import { PodrobnoComponent } from './repository/podrobno/podrobno.component';
import { PodrobnoServerComponent } from './repository/podrobno-server/podrobno-server.component';
import { RepositoryQueryGuard } from './services/auth/repository-query.guard';
import { UrediTaskGuard } from './services/auth/uredi-task.guard';
import { FaqTabComponent } from './faq-tab/faq-tab.component';
import { MessagesTabComponent } from './messages-tab/messages-tab.component';
import { AplikacijaHomeComponent } from './aplikacija/aplikacija-home/aplikacija-home.component';
import { IzbiraSkladiscaComponent } from './aplikacija/izbira-skladisca/izbira-skladisca.component';
import { AplikacijaHomeDocumentComponent } from './aplikacija/aplikacija-home-document/aplikacija-home-document.component';
import { FaqVideoComponent } from './faq-video/faq-video.component';
const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: '', component: HomeComponent, canActivate: [AuthGuardService]},
  { path: 'monitor', component: MonitorComponent, canActivate: [AuthGuardService]},
  { path: 'monitor-item', component: MonitorItemComponent, canActivate: [AuthGuardService]},
  { path: 'aplikacija-home', component: AplikacijaHomeComponent}, 
  { path: 'aplikacija-home-documents', component: AplikacijaHomeDocumentComponent}, 
  { path: 'izbira-skladisca', component: IzbiraSkladiscaComponent, canActivate: [AuthGuardService]},
  { path: 'prijavi-napako', component: PrijaviNapakoComponent, canActivate: [AuthGuardSharedServiceService]},
  // partner login
  { path: 'login-partner', component: LoginPartnerComponent},
  { path: 'faq', component: FaqTabComponent, canActivate: [AuthGuardSharedServiceService] },
  { path: 'faq-video', component: FaqVideoComponent, canActivate: [AuthGuardSharedServiceService] },
  { path: 'messages', component: MessagesTabComponent, canActivate: [AuthGuardService] },
  { path: 'pregled-helpdeska', component: PregledHelpdeskaComponent, canActivate: [AuthGuardSharedServiceService], },
  { path: 'uredi-task/:idTask', component: UrediTaskComponent, canActivate: [AuthUrediTaskGuard, UrediTaskGuard]},
  { path: 'helpdesk-tab', component: HelpdeskTabComponent, canActivate: [AuthGuardService]},
  //path za mail
  //{ path: 'mailToken/:token/:id', component: MailTokenComponent }
  { path: 'mailToken', component: MailTokenComponent },
  //{ path: 'map', component: MapBubbleChartComponent },
  { path: 'analiza', component: AnalizaComponent, canActivate: [AuthGuardService]},
  { path: 'prodaja', canActivate: [AuthGuardSharedServiceService],  children: [
    { path: 'izbira',  canActivate: [AuthGuardSharedServiceService], children: [
      {path: '', component: SaleSelectComponent, canActivate: [AuthGuardSharedServiceService]},
      { path: 'nadzorna_plosca', component: SaleSkladisceDesktopComponent, canActivate: [AuthGuardSharedServiceService] },
      { path: ':vrsta', component: SaleHomeComponent, canActivate: [AuthGuardSharedServiceService] }
    ]}
  ]},
  { path: 'odlagalisce', canActivate: [AuthGuardService], children: [
    {path: '', component: RepositoryComponent, canActivate: [AuthGuardService]},
    {path: 'podrobno-lumina-POS', component: PodrobnoComponent, canActivate: [AuthGuardService, RepositoryQueryGuard]},
    {path: 'podrobno-server', component: PodrobnoServerComponent, canActivate: [AuthGuardService, RepositoryQueryGuard]}
  ]},
];


@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled'
  , useHash: true})] ,
  exports: [RouterModule]
})

export class appRoutingModule { }
